import API from "@aws-amplify/api";
import {
  createChat,
  createChatMessage,
  updateChatMessage,
} from "../../graphql/mutations";
import {
  messagesByChat,
  getChatMessage,
  messagesByAgent,
} from "../../graphql/queries";
import { DataStore } from "@aws-amplify/datastore";
import { ChatMessage } from "../../models";
import { makeGraphQLRequest } from "..";
const createChatMessage_ = async (object) => {
  return makeGraphQLRequest({
    query: createChatMessage,
    variables: { input: object },
  });
};
const getChatMessage_ = async (id) => {
  return makeGraphQLRequest({
    query: getChatMessage,
    variables: { id },
  });
};
const updateChatMessage_ = async (id, args) => {
  const original = await getChatMessage_(id);
  let _properties = {};
  args.forEach((item) => {
    _properties[item.property] = item.value;
  });
  return makeGraphQLRequest({
    query: updateChatMessage,
    variables: {
      input: {
        id,
        _version: original?.data?.getChatMessage?._version,
        ..._properties,
      },
    },
  });
};

const getMessagesOffline_ = async (chatID) => {
  return DataStore.query(ChatMessage, (c) => c.chatID("eq", chatID));
};

const createChatMessageOffline_ = async (object) => {
  return DataStore.save(new ChatMessage(object));
};

const updateChatMessageOffline_ = async (id, args) => {
  const original = await DataStore.query(ChatMessage, id);
  return DataStore.save(
    ChatMessage.copyOf(original, (updated) => {
      args.forEach((arg) => {
        updated[arg.property] = arg.value;
      });
    })
  );
};

const getChatMessages_ = async (chatID) => {
  return makeGraphQLRequest({
    query: messagesByChat,
    variables: { chatID, sortDirection: "DESC", limit: 200 },
  });
};

const getChatMessagesByAgent_ = async (agentID) => {
  return makeGraphQLRequest({
    query: messagesByAgent,
    variables: {
      agentID,
      sortDirection: "DESC",
      limit: 10,
      filter: {
        humanFeedbackForInstruction: {
          eq: true,
        },
        humanFeedbackComment: {
          ne: null,
        },
      },
    },
  });
};
export default {
  createChatMessage: createChatMessage_,
  updateChatMessage: updateChatMessage_,
  updateChatMessageOffline: updateChatMessageOffline_,
  createChatMessageOffline: createChatMessageOffline_,
  getMessagesOffline: getMessagesOffline_,
  getChatMessages: getChatMessages_,
  getChatMessagesByAgent: getChatMessagesByAgent_,
};
